import MaterialTable from 'material-table';
import { defaultGridOptions, useGridColDefs } from '../../utils/GridUtils';
import { CircularProgress, makeStyles, TextField } from '@material-ui/core';
import { centeredCell } from '../../constants/StyleConstants';
import AnimatedButton from '../../components/UI/AnimatedButton';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import { Fragment } from 'react';
import { CancelOutlined, Edit } from '@material-ui/icons';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import LimitedBackdrop from '../../components/UI/LimitedBackdrop';
import BlockRoundedIcon from '@material-ui/icons/BlockRounded';
import { isValidEmail } from '../../utils/MiscellaneousUtils';
import { AppContext } from '../../contexts/AppContext';
import CancelIcon from "@material-ui/icons/Cancel";

const useStyles = makeStyles(theme => ({
  centeredCell,
  root: {
    marginTop: '3em',
  },
  gridActions: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '1em',
  },
  gridControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  gridButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '1em',
  },
  gridReference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: '1em',
    fontSize: '.8em',
  },
  reference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftSideButton: {
    borderRadius: '1em',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  rightSideButton: {
    borderRadius: '1em',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  activeGlow: {
    color: 'rgb(0, 255, 0)',
    boxShadow: '0px 0px 10px 0px rgb(0, 255, 0, .5)',
    borderRadius: '50%',
    margin: 0,
    stroke: 'rgb(0, 255, 0, .5)',
    strokeWidth: 4,
    strokeOpacity: 0.7,
  },
  hasNoComments: {
    color: '#BDBDBD',
  },
  sortButton: {
    '&.MuiButton-root': {
      minWidth: 'unset',
    },
    '&.MuiButton-startIcon': {
      margin: 0,
    },
  },
  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '30em',
  },
}));

const ModifyDialog = ({openModify, setOpenModify, validateAndConfirm, email, setEmail}) => {
  const classes = useStyles();
  const [openBackDrop, setOpenBackDrop] = useState(false);
  // const [email, setEmail] = useState('');

  // useEffect(() => {
  //   !openModify && setEmail('');
  // },[openModify])

  return (
    <Fragment>

      <DialogAcerBrag
        open={openModify}
        setOpen={setOpenModify}
      
        title={'Modificar email de notificación'}
        action={validateAndConfirm}>
        <LimitedBackdrop open={openBackDrop}>
          <CircularProgress color="primary" />
        </LimitedBackdrop>
        <div className={classes.dialogContainer}>

          <TextField
            margin="dense"
            id="email"
            label="Email"
            onChange={e => setEmail(e.target.value)}
            value={email}
            
          />

        </div>
      </DialogAcerBrag>
    </Fragment>
  );
}

const GridActions = ({
  selectedRows,
  // open,
  setOpen,
  handleExport,
  loadingExport,
  loading,
  sort,
  setSort,
  rows,
  newEmail,
  setNewEmail,
  modify,
  deleteEmail,
  ...restProps
}) => {
  const classes = useStyles();
  const { isAllowedByRole } = useContext(LoginContext);
  const { showWarning} = useContext(AppContext);
  const [openModify, setOpenModify] = useState(false);

  useEffect(() => {
    !openModify && setNewEmail('');
  }, [openModify])

  const validateModify = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    
    if ((errors[i++] = newEmail.isBlank())) {
      errorMessages.push('Debe completar el email');
    } else if ((errors[i++] = !isValidEmail(newEmail))) {
      errorMessages.push('El email ingresado no es válido');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  }

  const validateAndConfirm = () => {

    if(validateModify()){
      modify();
      setOpenModify(false)
    } 
  };


return  (
  <div className={classes.gridControls}>

      <div className={classes.gridButtonsWrapper}>
        <AnimatedButton
          disabled={selectedRows.isEmpty()}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Edit />}
          onClick={() => isAllowedByRole() && setOpenModify(true)}
          loading={loading}>
          Modificar email
        </AnimatedButton>
        <AnimatedButton
          disabled={selectedRows.isEmpty()}
          variant="contained"
          color="secondary"
          size="small"
          startIcon={<CancelIcon />}
          onClick={() => deleteEmail()}
          loading={loading}>
          Eliminar email
        </AnimatedButton>
        
      </div>
      <ModifyDialog openModify={openModify} setOpenModify={setOpenModify} validateAndConfirm={validateAndConfirm} email={newEmail} setEmail={setNewEmail} />

    </div>
  );
};

const EmailNotificationGrid = ({
  data,
  loading,
  tableRef,
  selectedRows,
  setSelectedRows,
  open,
  setOpen,
  newEmail,
  setNewEmail,
  gridActions,
}) => {
  const classes = useStyles();

  const BoldValue = ({ value }) => {
    return (<b>{value}</b>);
  };
  
  const colDefs = useGridColDefs([
    { title: 'emailId', field: 'emailId', hidden: true },
    { title: 'supplierId', field: 'supplierId', hidden: true },
    { title: 'Proveedor', field: 'user'},
    { title: 'Email De Notificación', field: 'email', valueRender: (value, rowData) => <BoldValue value={value} />  },

  ]);

  return (
    <Fragment>
      
      <div className={classes.root}>
        <div className={classes.gridActions}>
          <GridActions selectedRows={selectedRows} loading={loading} setOpen={setOpen} rows={data} newEmail={newEmail} setNewEmail={setNewEmail} {...gridActions} />
        </div>
        <MaterialTable
          {...defaultGridOptions}
          options={{
            ...defaultGridOptions.options,
            pageSizeOptions: [...defaultGridOptions.options.pageSizeOptions, defaultGridOptions.options.pageSizeOptions.last() * 2],
            selection: true,
            showSelectAllCheckbox: false,
            
            selectionProps: rowData => {
              return {
                color: 'primary',
                disabled: selectedRows.some(row => row.emailId !== rowData.emailId || row.user !== rowData.user) ,
                indeterminate: selectedRows.some(row => row.emailId !== rowData.emailId || row.user !== rowData.user) ,
                indeterminateIcon: <BlockRoundedIcon />,
              };
            },
          }}
          onSelectionChange={(rows, row) => setSelectedRows(rows.length > 0 ? [rows[0]] : [])}
          columns={colDefs}
          data={data}
          isLoading={loading}
          tableRef={tableRef}
        />
      </div>
    </Fragment>
  );
};

export default EmailNotificationGrid;